module.exports = __webpack_public_path__ + "static/img/宣传片-企业宣传片.a7ffaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/宣传片-企业宣传片.png
// module id = Fj8q
// module chunks = 1